module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table loginpage"
  }, [_c('div', {
    staticClass: "row vertical-10p logincntrrow"
  }, [_c('div', {
    staticClass: "container logincntr"
  }, [_c('div', {
    staticClass: "text-center col-md-4 col-sm-offset-4 loginFormwrp"
  }, [_c('img', {
    staticClass: "center-block logina-logo",
    attrs: {
      "src": "/static/img/d2dvoyager-logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "confirm passwordreset"
  }, [_c('h2', [_vm._v("Reset Password")]), _vm._v(" "), _c('div', {
    staticClass: "p-messagebubble"
  }, [_vm._v("The new password must be 8 character, contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)")]), _vm._v(" "), _c('div', {
    staticClass: "error loginModuleToperror"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: "errors.has('username')"
    }],
    staticClass: "error "
  }, [_vm._v(_vm._s(_vm.errors.first('username')))])]), _vm._v(" "), _c('form', {
    staticClass: "form-resetpassword",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.confirm($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        email: true
      }),
      expression: "{ email: true }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Username",
      "required": "",
      "name": "username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "blur": _vm.validemail,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmationCode),
      expression: "confirmationCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Confirmation Code",
      "required": ""
    },
    domProps: {
      "value": (_vm.confirmationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmationCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8|verify_password'),
      expression: "'required|min:8|verify_password'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "name": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "blur": _vm.validpassword,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group forgetsubmit"
  }, [_c('span', [_vm._v("If you are facing a issue, contact support on Yammer Group")]), _vm._v(" "), _c('button', {
    class: 'loginsubmit btn btn-primary btn-lg',
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca076758"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/PasswordReset.vue
// module id = 1009
// module chunks = 1